import React from 'react';


import {makeStyles} from '@material-ui/core/styles';
import CustomTable from '../../common/CustomTable';
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
}));

export default function CategoriesList(props) {
  const {
    data,
    handleStatusChange,
    statusNames,
    statusList,
    handleSearch,
    handleClear,
    handleEditClick,
    selectNames,
    // checked,
    // names,
    // setNames,
    // handleToggle,
    setSearchTerm,
    searchTerm,
    rowList,
    setRowList,
    headCells,
    productsAmount,
    handleMore,
    page,
    setPage,
    handleRequestSort,
    sortProperty,
    sortDirection,
    rowsPerPage,
    setRowsPerPage,
    // getFullList,
  } = props;
  const classes = useStyles();


  const cellList = headCells.map((cell) => {
    return cell.id;
  });

  return (
    <div className={classes.root}>
      <CustomTable
        actionsLists={[statusList]}
        actionsHandleChange={[handleStatusChange]}
        actionsNames={[statusNames]}
        headCells={headCells}
        cellList={cellList}
        data={data}
        filterIDs={[]}
        handleSearch={handleSearch}
        handleClear={handleClear}
        handleEditClick={handleEditClick}
        selectNames={selectNames}
        setSearchTerm={setSearchTerm}
        searchTerm={searchTerm}
        // checked={checked}
        // names={names}
        // setNames={setNames}
        // handleToggle={handleToggle}
        area="category"
        noChecks={true}
        rowList={rowList}
        setRowList={setRowList}
        productsAmount={productsAmount}
        handleMore={handleMore}
        page={page}
        setPage={setPage}
        handleRequestSort={handleRequestSort}
        sortProperty={sortProperty}
        sortDirection={sortDirection}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        // getFullList={getFullList}
      />
    </div>
  );
}
